
    <!--
 * 横版-页面导航
 * @LastEditTime: Mon Feb 17 2025 18:24:03 GMT+0800 (中国标准时间)
 -->
 <template>
  <div id="u_c_H25469"  v-show="compData.isShow" :class="[`normal`,`u_c_H25469`]" ><div id="u_c_VWS917"  v-for="(btnItem, btnI) in compData.btnList" :key="btnI" :class="[`normal`,`u_c_VWS917`]" ><a id="u_c_GNP830" href="javascript:;" :style="`${ btnItem.pic ? `background-image:url(${ btnItem.pic })` : '' }`" :data-target="btnItem.block" :class="[`${ btnItem.cur ? 'cur' : '' }`,`normal btn-light nav-btn`,`u_c_GNP830`]" @click="u_c_GNP830_event_F9W931($event,btnI,btnItem.block,btnItem.link)"><div id="u_c_AI7827"  v-html="pageData.isEdit ? btnItem.text : getBtnText(btnItem)" :class="[`normal`,`u_c_AI7827`]" ></div></a></div></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";


    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{"btnList":[{"pic":"","block":"u_c_V3GG18","link":"https://pay.37games.com/platform/officialWebStore.html?gameId=390","text":"每日\n首充"},{"pic":"","block":"u_c_PU3219","link":"https://pay.37games.com/platform/officialWebStore.html?gameId=390","text":"签到\n获豪礼"},{"pic":"","block":"pay","link":"https://pay.37games.com/platform/officialWebStore.html?gameId=390","text":"前往\n充值"},{"pic":"","block":"u_c_JDH534","link":"https://pay.37games.com/platform/officialWebStore.html?gameId=390","text":"幸运\n抽奖"},{"pic":"","block":"u_c_699X21","link":"https://pay.37games.com/platform/officialWebStore.html?gameId=390","text":"奖励\n送不停"}],"isShow":true},"en-US":{"btnList":[{"pic":"","block":"u_c_V3GG18","link":"https://pay.37games.com/platform/officialWebStore.html?gameId=390","text":"1st Top-up Gift\n"},{"pic":"","block":"u_c_PU3219","link":"https://pay.37games.com/platform/officialWebStore.html?gameId=390","text":"Sign-in Gift\n"},{"pic":"","block":"pay","link":"https://pay.37games.com/platform/officialWebStore.html?gameId=390","text":"Top Up\n"},{"pic":"","block":"u_c_7PIQ17","link":"https://pay.37games.com/platform/officialWebStore.html?gameId=390","text":"Valentine's Day Pack"},{"pic":"","block":"u_c_699X21","link":"https://pay.37games.com/platform/officialWebStore.html?gameId=390","text":"Bonus Gift\n"}],"isShow":true},"ru-RU":{"btnList":[{"pic":"","block":"u_c_V3GG18","link":"https://pay.37games.com/platform/officialWebStore.html?gameId=390","text":"1st Top-up Gift\n"},{"pic":"","block":"u_c_PU3219","link":"https://pay.37games.com/platform/officialWebStore.html?gameId=390","text":"Sign-in Gift\n"},{"pic":"","block":"pay","link":"https://pay.37games.com/platform/officialWebStore.html?gameId=390","text":"Top Up\n"},{"pic":"","block":"u_c_JDH534","link":"https://pay.37games.com/platform/officialWebStore.html?gameId=390","text":"Набор ко Дню Святого Валентина"},{"pic":"","block":"u_c_699X21","link":"https://pay.37games.com/platform/officialWebStore.html?gameId=390","text":"Bonus Gift\n"}],"isShow":true},"pt-PT":{"btnList":[{"pic":"","block":"u_c_V3GG18","link":"https://pay.37games.com/platform/officialWebStore.html?gameId=390","text":"1st Top-up Gift\n"},{"pic":"","block":"u_c_PU3219","link":"https://pay.37games.com/platform/officialWebStore.html?gameId=390","text":"Sign-in Gift\n"},{"pic":"","block":"pay","link":"https://pay.37games.com/platform/officialWebStore.html?gameId=390","text":"Top Up\n"},{"pic":"","block":"u_c_JDH534","link":"https://pay.37games.com/platform/officialWebStore.html?gameId=390","text":"Pacote de Dia dos Namorados"},{"pic":"","block":"u_c_699X21","link":"https://pay.37games.com/platform/officialWebStore.html?gameId=390","text":"Bonus Gift\n"}],"isShow":true}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['en-US']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();
    const compName = '页面导航';

    // 自定义setup - 开始
    const getCurLink = inject("getCurLink", (link) => {})

const init = () => {
  compData.isShow = true;
  if (bridge.runInsdk()) {
    compData.btnList = compData.btnList.filter((item) => {
      return item.block != "pay";
    });
  }
  compData.btnList.forEach((item) => {
    if (item.link) {
      item.link = utils.getStoreLinkWithCidScid({
        link: item.link,
        paramsObj: {
          language: curLang,
          gameId: pageData.gameId,
        },
        pageId: pageData.pageId,
      })
    }
  })
}

init()
// 获取按钮名称
const getBtnText = (item) => {
  if (item.block === "pay") {
    return getLangTxt("goPay");
  }
  if (item.block === "download") {
    return getLangTxt("downloadGame");
  }
  return item.text;
};

let sectionPosition = []
onMounted(() => {
  let curScroll = document.documentElement.scrollTop
  compData.btnList.forEach((item, index) => {
    if (item.block && !["pay", "download"].includes(item.block)) {
      let _ele = document.getElementById(item.block)
      if (_ele) {
        let _p = _ele.getBoundingClientRect()
        sectionPosition.push({
          top: Math.floor(_p.top + curScroll + _p.height / 3),
          realTop: Math.floor(_p.top + curScroll),
          index,
        })
      }
    }
  })
  const throttledFn = vueUse.useThrottleFn(() => {
    let curScroll = document.documentElement.scrollTop
    let curIndex = sectionPosition.findIndex((item) => item.top > curScroll)
    if (~curIndex) {
      compData.btnList.forEach((item, index) => {
        if (index == sectionPosition[curIndex].index) {
          item.cur = 1
        } else {
          item.cur = 0
        }
      })
    }
  })
  window.addEventListener("scroll", throttledFn)
  throttledFn()
});
      // 自定义元素GNP830的click事件
      const u_c_GNP830_event_F9W931= async (e,index,block,link)=>{
        try {window.activityDataLayer.push({
  eventName: "click_button",
  eventType: `导航栏-${index}`,
  gameId: pageData.gameId,
  aid: pageData.pageId,
})

if (!block || ["pay", "download"].includes(block)) {
  if (block === "pay") {
    bridge.open(pageData.storeLink);
    return;
  }
  bridge.open(link)
} else {
  let curTopIndex = sectionPosition.findIndex(
    (item) => item.index == index
  )
  if (~curTopIndex) {
    window.scrollTo({
      top: sectionPosition[curTopIndex].realTop,
      behavior: "smooth",
    })
  }
}} catch (error) {console.log(error)}
      }
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_H25469.normal{
position:fixed;
right:0;
top:0;
font-size:0;
height:100%;
display:flex;
justify-content:center;
align-items:center;
flex-direction:column;
z-index:5;

}
}.default{
.u_c_VWS917.normal{
position:relative;
display:block;

}
}.default{
.u_c_GNP830.normal{
position:relative;
display:flex;
width:8.75vw;
height:6.67vw;
background:no-repeat 0 50%;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/02/1739434540574-61.png);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_GNP830.normal.cur{
filter:brightness(1.4);

}
}.default{
.u_c_AI7827.normal{
position:relative;
font-size:1.04vw;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}
}.en-US{
.u_c_H25469.normal{
position:fixed;
right:0;
top:0;
font-size:0;
height:100%;
display:flex;
justify-content:center;
align-items:center;
flex-direction:column;
z-index:5;

}
}.en-US{
.u_c_VWS917.normal{
position:relative;
display:block;

}
}.en-US{
.u_c_GNP830.normal{
position:relative;
display:flex;
width:8.75vw;
height:6.67vw;
background:no-repeat 0 50%;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/02/1739434540574-61.png);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_GNP830.normal.cur{
filter:brightness(1.4);

}
}.en-US{
.u_c_AI7827.normal{
position:relative;
font-size:1.04vw;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}
}.ru-RU{
.u_c_H25469.normal{
position:fixed;
right:0;
top:0;
font-size:0;
height:100%;
display:flex;
justify-content:center;
align-items:center;
flex-direction:column;
z-index:5;

}
}.ru-RU{
.u_c_VWS917.normal{
position:relative;
display:block;

}
}.ru-RU{
.u_c_GNP830.normal{
position:relative;
display:flex;
width:8.75vw;
height:6.67vw;
background:no-repeat 0 50%;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/02/1739434540574-61.png);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_GNP830.normal.cur{
filter:brightness(1.4);

}
}.ru-RU{
.u_c_AI7827.normal{
position:relative;
font-size:1.04vw;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}
}.pt-PT{
.u_c_H25469.normal{
position:fixed;
right:0;
top:0;
font-size:0;
height:100%;
display:flex;
justify-content:center;
align-items:center;
flex-direction:column;
z-index:5;

}
}.pt-PT{
.u_c_VWS917.normal{
position:relative;
display:block;

}
}.pt-PT{
.u_c_GNP830.normal{
position:relative;
display:flex;
width:8.75vw;
height:6.67vw;
background:no-repeat 0 50%;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/02/1739434540574-61.png);
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_GNP830.normal.cur{
filter:brightness(1.4);

}
}.pt-PT{
.u_c_AI7827.normal{
position:relative;
font-size:1.04vw;
color:#ffffff;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}
}
</style>
